import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AddMembershipResponse } from "app/models/webex/add-membership-response.model";
import { JwtTokenLoginResponse } from "app/models/webex/jwt-token-login-response.model";
import { RoomModel } from "app/models/webex/room.model";
import { RoomsConfig, SaveRoomsHistory } from "app/models/webex/rooms-config.model";
import { UserWebex } from "app/models/webex/user-webex.model";
import { BehaviorSubject, Observable } from "rxjs";
import { AuthService } from "./auth.service";
import { ConfigsLoaderService } from "./config-loader.service";


@Injectable({providedIn: 'root'})
export class WebexService {

    private apiWebexUrl = 'https://webexapis.com/v1';
    private apiUrl = '';
    public continueObservable: BehaviorSubject<string> = new BehaviorSubject<string>('webex close'); 

    constructor(
        private http: HttpClient,
        private auth: AuthService,
        private config: ConfigsLoaderService,
    ){
        this.apiUrl = `${this.config.apiUrl}/`;
    }

    login(headers): Observable<JwtTokenLoginResponse>{
        return this.http.post<JwtTokenLoginResponse>(this.apiWebexUrl + '/jwt/login' , {}, { headers });
    }

    generateRoom(data, headers): Observable<RoomModel>{
        return this.http.post<RoomModel>(this.apiWebexUrl + '/rooms', data, { headers });
    }

    addMembers(headers, newMembershipData): Observable<AddMembershipResponse>{
        return this.http.post<AddMembershipResponse>(this.apiWebexUrl + '/memberships', newMembershipData, { headers })
    }

    getUserWebex(): Observable<UserWebex>{
        return this.http.get<UserWebex>(this.apiUrl + 'Webex/UserWebex');
    }

    getRoomsConfig(): Observable<RoomsConfig[]>{
        return this.http.get<RoomsConfig[]>(this.apiUrl + 'Webex/Room');
    }

    saveRoomsHistory(data: SaveRoomsHistory){
        return this.http.post(this.apiUrl + 'Webex/RoomHistory', data);
    }
}